<script setup lang="ts">
defineProps<{
  title: string;
  text: string;
  closeText: string;
}>();
const emit = defineEmits<{
  (e: "close"): void;
}>();
</script>
<template>
  <Teleport to="body">
    <div class="modal-area">
      <div class="modal-base">
        <div class="content">
          <div class="title">{{ title }}</div>
          <div class="text">{{ text }}</div>
        </div>
        <div class="controls">
          <button class="modal-control" @click="emit('close')">
            {{ closeText }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>
<style scoped>
.modal-area {
  width: 100vw;
  height: 100%;
  height: 100dvh;
  left: 0;
  top: 0;
  position: absolute;
  background: rgba(41, 41, 41, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal-base {
  width: 560px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 11px 15px 0px rgba(0, 0, 0, 0.20), 0px 9px 46px 0px rgba(0, 0, 0, 0.12), 0px 24px 38px 0px rgba(0, 0, 0, 0.14);
  background: #FFF;
  border-radius: 4px;
}

.content {
  padding: 20px 24px 0 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.title {
  color: #292929;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.text {
  color: #292929;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.controls {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  padding: 8px 16px;
}

button.modal-control {
  background: transparent;
  height: 36px;
  padding: 10px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  color: #19a8cc;
  border: none;
  cursor: pointer;
}
</style>
